/* eslint-disable no-unused-vars */
// linter gives a false-positive for typescript-enums, needs to investigate
export enum ChatChannelRolesEnum {
  IDENTIFIED_VIEWER = 'identified_viewer',
  ANONYMOUS_VIEWER = 'anonymous_viewer',
  CREATOR = 'creator',
}
